import StoreIcon from '@mui/icons-material/Store'

export default function SubmerchantIcon() {
    return (
        <StoreIcon />
    )
}
